import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroTomador from '../../actions/cteos/tomador/adicionarFiltroTomador'
import removerFiltroTomador from '../../actions/cteos/tomador/removerFiltroTomador'
import FiltroBusca from '../comum/FiltroBusca'

export class FiltroBuscaTomador extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isNome={this.props.isNome}
        isNumero={this.props.isNumero}
        adicionarFiltro={this.props.adicionarFiltroTomador}
        removerFiltro={this.props.removerFiltroTomador}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosTomador
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroTomador,
    removerFiltroTomador,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaTomador)
